exports.default = "<div class=\"we_widgetBox\"> <div class=\"header\"> <div class=\"title\">${model.title}</div> </div> <div class=\"content\"> </div> </div>";